module.exports = __webpack_public_path__ + "static/media/OneForChildren_Logo.f5c1444d.svg";